/* Loads the home-page tightening, bottom bar styles and bottom bar script that sit beside this file. */
(function () {
  var V = '20261018k';
  var cur = document.currentScript;
  var src = (cur && cur.src) || '';
  if (!src) { var el = document.querySelector('script[src*="petsofy-motion.js"]'); src = el ? el.src : ''; }
  if (!src) return;
  var base = src.split('?')[0].replace(/petsofy-motion\.js$/, '');
  ['petsofy-home.css', 'petsofy-dock.css'].forEach(function (n) {
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = base + n + '?v=' + V;
    document.head.appendChild(l);
  });
  var d = document.createElement('script');
  d.src = base + 'petsofy-dock.js?v=' + V;
  document.head.appendChild(d);
})();

/* Pet Hotel calendar: a day the hotel is closed for arrivals and departures (holiday, closed weekday, too soon for
   the notice period) says "Closed" instead of "Full". The ERP marks those days with closed: true. */
(function () {
  var p = location.pathname.replace(/^\/ar(?=\/)/, '');
  if (!/^\/products\/pets-hotel-service\/?$/.test(p)) return;
  var ar = /^\/ar(\/|$)/.test(location.pathname);
  var API = 'https://admin.petsofy.net/api/public/hotel/availability';
  var cache = {};
  function paint(grid) {
    var days = grid.querySelectorAll('[data-date]');
    if (!days.length) return;
    var key = days[0].getAttribute('data-date').slice(0, 7);
    function apply(data) {
      Array.prototype.forEach.call(grid.querySelectorAll('[data-date]'), function (btn) {
        var info = data[btn.getAttribute('data-date')];
        var label = btn.querySelector('.room-booking__calendar-day-avail');
        if (info && info.closed && label && label.textContent !== (ar ? 'مغلق' : 'Closed')) label.textContent = ar ? 'مغلق' : 'Closed';
      });
    }
    if (cache[key]) { apply(cache[key]); return; }
    var parts = key.split('-');
    fetch(API + '?year=' + parts[0] + '&month=' + Number(parts[1]))
      .then(function (r) { return r.json(); })
      .then(function (data) { cache[key] = data; apply(data); })
      .catch(function () {});
  }
  function watch() {
    var grid = document.querySelector('[data-rb-cal-grid]');
    if (!grid || !window.MutationObserver) return;
    new MutationObserver(function () { paint(grid); }).observe(grid, { childList: true, subtree: true });
    paint(grid);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* Search results page: say how many results there are (the template shows none). */
(function () {
  if (!/^\/(ar\/)?search\/?$/.test(location.pathname)) return;
  var m = document.title.match(/(\d+)\s+results?\s+found\s+for\s+(.+?)\s+[–-]\s/i);
  if (!m) return;
  var term = m[2].replace(/^[\s"'“”]+|[\s"'“”]+$/g, '');
  function add() {
    var form = document.querySelector('main form[action*="search"], main form[role="search"]');
    if (!form || document.querySelector('.pz-search-count')) return;
    var p = document.createElement('p');
    p.className = 'pz-search-count';
    var strong = document.createElement('strong');
    strong.textContent = m[1];
    p.appendChild(strong);
    p.appendChild(document.createTextNode(' results for “' + term + '”'));
    form.insertAdjacentElement('afterend', p);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

/* Every product page: a Back button above the product, like the category pages have. */
(function () {
  if (!/^\/(ar\/)?products\//.test(location.pathname)) return;
  var ar = /^\/ar(\/|$)/.test(location.pathname);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (ar ? '/ar/' : '/');
  var st = document.createElement('style');
  st.textContent =
    '.pz-pback { padding-top: 14px; padding-bottom: 4px; }' +
    '.pz-pback__btn { display: inline-flex; align-items: center; gap: 8px; min-height: 42px; padding: 0 18px 0 12px; border: 1px solid rgba(201, 164, 92, 0.45); border-radius: 999px; background: rgba(255, 255, 255, 0.06); color: #e7c98a; font: inherit; font-size: 14.5px; font-weight: 600; cursor: pointer; transition: background 0.2s, color 0.2s, transform 0.2s; }' +
    '.pz-pback__btn:hover, .pz-pback__btn:focus-visible { background: #c9a45c; color: #06332d; transform: translateX(-2px); }' +
    '.pz-pback__btn svg { width: 18px; height: 18px; }';
  document.head.appendChild(st);
  function add() {
    var c = document.querySelector('.product-template__container');
    if (!c || document.querySelector('.pz-pback')) return;
    var wrap = document.createElement('div');
    wrap.className = 'pz-pback page-width';
    wrap.innerHTML = '<button type="button" class="pz-pback__btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg><span>' + (ar ? 'رجوع' : 'Back') + '</span></button>';
    c.parentNode.insertBefore(wrap, c);
    wrap.querySelector('button').addEventListener('click', function () {
      var sameSite = false;
      try { sameSite = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) {}
      if (sameSite && history.length > 1) { history.back(); return; }
      // Opened from outside the shop (a shared link, a search): go to the product's own collection.
      var links = document.querySelectorAll('.breadcrumbs a[href*="/collections/"], nav[aria-label*="readcrumb"] a[href*="/collections/"]');
      var last = links.length ? links[links.length - 1].getAttribute('href') : '';
      window.location.href = last || (root + 'collections/all');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();

/* Pet Hotel and Grooming pages: fold the long description into a tap-to-open "Details & prices" block (phones only). */
(function () {
  var p = location.pathname.replace(/^\/ar(?=\/)/, '');
  if (!/^\/products\/(grooming-1|pets-hotel-service)\/?$/.test(p)) return;
  document.documentElement.classList.add('pz-svc');
  function fold() {
    try {
      var d = document.querySelector('.product-single__description');
      if (!d || d.parentNode.classList.contains('pz-more')) return;
      var det = document.createElement('details');
      det.className = 'pz-more';
      var sum = document.createElement('summary');
      sum.textContent = /^\/ar(\/|$)/.test(location.pathname) ? 'التفاصيل والأسعار' : 'Details & prices';
      d.parentNode.insertBefore(det, d);
      det.appendChild(sum);
      det.appendChild(d);
      if (!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches)) det.open = true;
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fold); else fold();
})();

/* Grooming page: nothing is chosen here. The pet and the services are asked once, in the booking pop-up, so the
   pet / grooming-type selectors, the price of one variant, quantity and Add to cart are hidden. */
(function () {
  var p = location.pathname.replace(/^\/ar(?=\/)/, '');
  if (!/^\/products\/grooming-1\/?$/.test(p)) return;
  var ar = /^\/ar(\/|$)/.test(location.pathname);
  document.documentElement.classList.add('pz-grooming');
  var st = document.createElement('style');
  st.textContent =
    'html.pz-grooming product-form, html.pz-grooming .shopify-payment-button, html.pz-grooming .product-form__stock-notification, html.pz-grooming variant-selects, html.pz-grooming .product__price, html.pz-grooming .product-header__info, html.pz-grooming .floating-contact-toggle, html.pz-grooming .contact-popup-menu { display: none !important; }' +
    '.pz-from { margin: 4px 0 2px; text-align: center; color: #06332d; }' +
    '.pz-from span { display: block; font-size: 12px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; opacity: 0.65; }' +
    '.pz-from strong { display: block; font-family: var(--font-heading-family); font-weight: 500; font-size: 34px; line-height: 1.15; }' +
    '.pz-from[hidden] { display: none; }' +
    '.pz-price-note { margin: 2px 0 14px; font-size: 13.5px; line-height: 1.45; color: rgba(60, 60, 66, 0.85); text-align: center; }' +
    '.pz-book-box { display: grid; gap: 10px; margin: 0 0 4px; width: 100%; }' +
    '.pz-book { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; min-height: 54px; padding: 0 22px; border: 0; border-radius: 999px; cursor: pointer; font-family: inherit; background: linear-gradient(135deg, #f0d9a3, #c9a45c); color: #06332d !important; font-size: 15px; font-weight: 800; letter-spacing: 0.02em; text-decoration: none; box-shadow: 0 10px 24px rgba(201, 164, 92, 0.3); }' +
    '.pz-book svg, .pz-wa-book svg { width: 22px; height: 22px; flex: none; }' +
    '.pz-wa-book { display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%; min-height: 50px; padding: 0 22px; border-radius: 999px; border: 1.5px solid #06332d; background: transparent; color: #06332d !important; font-size: 14.5px; font-weight: 700; text-decoration: none; }' +
    '.pz-book:active, .pz-wa-book:active { transform: scale(0.98); }';
  document.head.appendChild(st);
  var API = 'https://admin.petsofy.net/api/public/grooming';
  var CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>';
  var WAI = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20l1.2-4A8 8 0 1 1 8.2 19L4 20z"/><path d="M9 9.5c.3 2 2 3.8 4.5 4.5l1.2-1.2-1.8-1-.8.6c-.8-.4-1.4-1-1.8-1.8l.6-.8-1-1.8L9 9.5z"/></svg>';
  function build() {
    var box = document.querySelector('.product-form__buy-buttons');
    if (!box || box.querySelector('.pz-book-box')) return;

    // The price line the page used to show was one variant's price (cat, Basic). The real range comes from the ERP.
    var pr = document.querySelector('.product__price');
    if (pr && !document.querySelector('.pz-from')) {
      var from = document.createElement('div');
      from.className = 'pz-from';
      from.hidden = true;
      from.innerHTML = '<span>' + (ar ? 'ابتداءً من' : 'From') + '</span><strong></strong>';
      var note = document.createElement('p');
      note.className = 'pz-price-note';
      note.textContent = ar ? 'يختلف السعر حسب حيوانك والخدمات. تختارها عند الحجز.' : 'The price depends on your pet and the services. You choose them when you book.';
      pr.parentNode.insertBefore(from, pr);
      pr.parentNode.insertBefore(note, pr);
      fetch(API + '/catalog').then(function (r) { return r.json(); }).then(function (c) {
        var prices = (c.items || []).map(function (i) { return i.price; });
        if (!prices.length) return;
        from.querySelector('strong').textContent = Math.min.apply(null, prices).toFixed(3) + (ar ? ' د.ك' : ' KD');
        from.hidden = false;
      }).catch(function () {});
    }

    var wrap = document.createElement('div');
    wrap.className = 'pz-book-box';
    var msg = ar ? 'مرحباً، أرغب بحجز موعد عناية لحيواني' : 'Hi Petsofy, I would like to book a grooming appointment for my pet';
    wrap.innerHTML =
      '<button type="button" class="pz-book">' + CAL + '<span>' + (ar ? 'احجز موعداً' : 'Book an appointment') + '</span></button>' +
      '<a class="pz-wa-book" target="_blank" rel="noopener" href="https://wa.me/96597151577?text=' + encodeURIComponent(msg) + '">' + WAI + '<span>' + (ar ? 'اسأل عبر واتساب' : 'Ask on WhatsApp') + '</span></a>';
    box.appendChild(wrap);
    wrap.querySelector('.pz-book').addEventListener('click', function () {
      if (window.PzGroomingBooking) window.PzGroomingBooking.open();
      else window.open(wrap.querySelector('.pz-wa-book').href, '_blank', 'noopener');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
})();

/* Petsofy motion layer: scroll progress bar + scroll-reveal with stagger.
   No dependencies. Does nothing for visitors who prefer reduced motion. */
(function () {
  var doc = document;
  var root = doc.documentElement;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  root.classList.add('pz-js');

  function start() {
    /* ---- scroll progress bar ---- */
    var bar = doc.createElement('div');
    bar.id = 'pz-progress';
    bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = root.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, window.scrollY / h) : 0) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();

    /* ---- scroll reveal ---- */
    // Elements the theme does not already animate itself (it fades its own `.scroll-animate` blocks in).
    var SELECTORS = [
      '[class*="ai-round-offer-list__item"]',
      '.feature-row',
      '.feature-cards__item',
      '.collection-grid-item',
      '.site-footer__content > *',
      '.product__info-container',
      'media-gallery',
      'main .rte > *',
      '.page-width > .rich-text__content > *'
    ];
    var items = [];
    SELECTORS.forEach(function (sel) {
      doc.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('.scroll-animate') || el.classList.contains('pz-reveal')) return;
        if (el.closest('[hidden], .drawer, .menu-drawer-container')) return;
        items.push(el);
      });
    });
    var perParent = new Map();
    items.forEach(function (el) {
      var p = el.parentElement;
      var n = perParent.get(p) || 0;
      perParent.set(p, n + 1);
      el.style.setProperty('--pzd', Math.min(n, 6) * 90 + 'ms');
      el.classList.add('pz-reveal');
      if (/round-offer-list__item/.test(el.className)) el.classList.add('pz-reveal--zoom');
    });

    var lines = [].slice.call(doc.querySelectorAll('.section__header'));
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('pz-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    items.concat(lines).forEach(function (el) { io.observe(el); });

    // Fail-safe: never leave content hidden if the observer is delayed.
    window.setTimeout(function () {
      items.concat(lines).forEach(function (el) { el.classList.add('pz-in'); });
    }, 7000);
  }

  if (doc.body) start(); else doc.addEventListener('DOMContentLoaded', start);
})();
